import { noSerialize } from "@builder.io/qwik";
function noSerializeWrapper(fn) {
  return noSerialize(fn);
}
export {
  noSerializeWrapper
};
